import React from 'react';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
const Row = (props) => {
    return (React.createElement(RowStyled, { className: `row ${props.className}`, style: props.style }, props.children));
};
export default Row;
const RowStyled = styled.div `
  &.row {
    margin-left: -${THEME.GRID_SPACING / 2}px;
    margin-right: -${THEME.GRID_SPACING / 2}px;
  }
  &.row:before,
  &.row:after {
    content: ' ';
    display: table;
  }
  &.row:after {
    clear: both;
  }
`;
//# sourceMappingURL=Row.js.map